import { EImportSectionsTarget } from '@constants';
import { Flex, Input } from 'antd';
import { isEmpty } from 'lodash';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';

import { ContentSearchEmptyPage } from '../ContentSearchEmptyPage';

import { IntroductionForm } from './IntroductionForm';
import { IntroductionSectionItem } from './IntroductionSectionItem';
import { Wrapper } from './IntroductionSections.styles';

import { ActivityPreview } from '@/components/ActivityPreview';
import { AddSection, ImportSection } from '@/components/SectionManagement';
import { SectionsAndIntroductionEmptyPage } from '@/components/SectionsAndIntroductionEmptyPage';
import { useSearchSections } from '@/hooks/useSearchSections';
import { useCourseDetail } from '@/store';

export const IntroductionSections = () => {
  const [openSectionIds, setOpenSectionIds] = useState<string[]>([]);
  const { t } = useTranslation('ManagerBaseContentDetailTranslations');
  const { course } = useCourseDetail();
  const target = EImportSectionsTarget.INTRODUCTION;
  const {
    searchValue,
    setSearchValue,
    filteredSections: filteredIntroductions
  } = useSearchSections(course?.introduction);

  if (!course) return null;

  const { introduction = [] } = course;
  const isSectionsEmpty = isEmpty(introduction);
  const isSectionsFilteredEmpty = isEmpty(filteredIntroductions) && !isSectionsEmpty;

  const handleToggleSection = (sectionId: string) => {
    setOpenSectionIds(prev =>
      prev.includes(sectionId) ? prev.filter(id => id !== sectionId) : [...prev, sectionId]
    );
  };

  return (
    <Wrapper>
      {isSectionsEmpty && (
        <SectionsAndIntroductionEmptyPage target={target} fetchOnlyParentsCourses />
      )}
      <Flex justify="space-between" align="center">
        {!isSectionsEmpty && (
          <Input.Search
            placeholder={t('SEARCH_SECTIONS_OR_ACTIVITIES_BY_NAME')}
            value={searchValue}
            onChange={e => setSearchValue(e.target.value)}
            allowClear
            style={{ width: '100%', maxWidth: 400 }}
          />
        )}
        <Flex gap={8}>
          {!isSectionsEmpty && (
            <>
              <AddSection course={course} target={target} />
              <ImportSection target={target} fetchOnlyParentsCourses />
            </>
          )}
        </Flex>
      </Flex>

      {isSectionsFilteredEmpty && <ContentSearchEmptyPage />}
      {filteredIntroductions.map(section => (
        <IntroductionSectionItem
          key={section._id}
          section={section}
          isOpen={openSectionIds.includes(section._id)}
          onToggle={handleToggleSection}
        />
      ))}
      <IntroductionForm />
      <ActivityPreview />
    </Wrapper>
  );
};
